import { Box, useTheme } from '@mui/material';
import { FloatIcon } from 'src/assets/widgets/FloatIcon';
import { useResponsive } from 'src/hooks/useResponsive';

type Props = {
  floatTop: string;
  leftPosition: number;
  isUnderTheWater: boolean;
};

export const FloatItem = ({ floatTop, leftPosition, isUnderTheWater }: Props) => {
  const isMobile = useResponsive('down', 600);
  const theme = useTheme();

  const mainColor = theme.palette.primary.main;

  return (
    <Box>
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: `${leftPosition}px`,
          width: isMobile ? '1px' : '2px',
          height: floatTop,
          backgroundColor: '#657289',
        }}
      />

      <Box
        sx={{
          position: 'absolute',
          top: floatTop,
          left: isMobile ? `${leftPosition - 6}px` : `${leftPosition - 7}px`,
          width: 14,
          height: 14,
          transform: 'translateY(-50%)',
        }}
      >
        <FloatIcon
          width={isMobile ? 13 : 18}
          height={isMobile ? 28 : 32}
          fill={isUnderTheWater ? mainColor : '#8896AE'}
        />
      </Box>
    </Box>
  );
};
